import { CardItem, CardItemLabel, CardItemContent, CardItemValue } from '../ui/details-card';
import Text from '../ui/text';
import { MapPin, Phone } from 'lucide-react'
import { formatPhoneNumber } from '../../lib/utils';

const PharmacyDetails = props => {
  const { data = {} } = props;

  return (
    <div className='w-full flex flex-col md:flex-row gap-5 md:gap-10 md:justify-between'>
        <CardItem>
            <CardItemLabel><Text>Name</Text></CardItemLabel>
            <CardItemContent>
                <CardItemValue>{data?.providerName}</CardItemValue>
            </CardItemContent>
        </CardItem>
        <CardItem>
            <CardItemLabel><Text>Address</Text></CardItemLabel>
            <CardItemContent>
                <div><MapPin size={28} strokeWidth={1} className='text-primary'/></div>
                <CardItemContent className='flex flex-col gap-1'>
                    <CardItemValue>{data?.providerAddress1}{data?.providerAddress2 ? `, ${data?.providerAddress2}` : ''}</CardItemValue>
                    <CardItemValue>{data?.providerCity}, {data?.providerState} {data?.providerZip}</CardItemValue>
                </CardItemContent>
            </CardItemContent>
        </CardItem>
        <CardItem>
            <CardItemLabel><Text>Phone Number</Text></CardItemLabel>
            <CardItemContent>
                <div><Phone size={28} strokeWidth={1} className='text-primary'/></div>
                <CardItemValue>{(data?.providerPhone ? <a href={`tel:${data.providerPhone}`} className='underline text-gray-800 hover:text-gray-800 font-normal'>{formatPhoneNumber(data?.providerPhone)}</a> : null)}</CardItemValue>
            </CardItemContent>
        </CardItem>
    </div>
  );
};

export default PharmacyDetails;
